import ContentDisposition from 'content-disposition';

export const downloadBinaryResponse = (response) => {
  console.log('downloadBinaryResponse', { response });
  const { headers } = response;
  const contentDisposition = ContentDisposition.parse(headers['content-disposition']);
  console.log('downloadBinaryResponse', {
    headers,
    contentDisposition,
  });
  const contentType = headers['content-type'];
  const file = new Blob(
    [response.data],
    { type: contentType },
  );
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveOrOpenBlob(file, contentDisposition?.parameters?.filename);
  } else {
    const data = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = data;
    a.download = contentDisposition?.parameters?.filename;
    if (typeof a.download === 'undefined') {
      a.setAttribute('target', '_blank');
    }
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(data);
    }, 200);
  }
};

export default {};
